import React, { useState } from "react";
import { useForm } from "react-hook-form";

const MultiplePoints = ({
  Responsibilities,
  setResponsibilities,
  datalimit,
}) => {
  const [Res, setRes] = useState("");
  //   const [] = useState([]);
  const {
    register,
    // handleSubmit,
    setValue,
    getValues,
    // reset,
    // formState: { isSubmitting },
  } = useForm();

  const AddDataArray = () => {
    if (Res) {
      if (!datalimit || datalimit > Responsibilities?.length)
        // setResponsibilities({ ...Responsibilities, [Res]: [] });
        setResponsibilities((prev) => [...prev, { heading: Res }]);
    }
    setRes("");
  };
  const RemoveDataArray = (item) => {
    setResponsibilities((prevData) => {
      // const newData = { ...prevData }; // Create a shallow copy of the object
      // delete newData[item]; // Remove the key
      return prevData.filter((it) => it.heading !== item); // Update state with the new object
    });
  };

  const RemoveArraySubItem = (key, item) => {
    setResponsibilities((prevData) => {
      // const newData = { ...prevData }; // Create a shallow copy of the object
      // newData[key] = newData[key].filter((subItem) => subItem !== item); // Remove the key
      return prevData.map((it) =>
        it.heading === key
          ? { ...it, points: it?.points?.filter((sub) => sub !== item) ?? [] }
          : it
      );
    });
  };

  const AddSubItem = () => {
    if (
      !getValues("ProductSubItem") ||
      !getValues("ProductSelected") ||
      getValues("ProductSubItem") == "" ||
      getValues("ProductSelected") == ""
    ) {
      console.log("no item");
      return;
    }

    let item = [...Responsibilities];
    if (getValues("ProductSubItemType") === "link") {
      item = item.map((it) =>
        it.heading === getValues("ProductSelected")
          ? { ...it, link: getValues("ProductSubItem"), points: [] } // Update `data`
          : it
      );
    } else {
      item = item.map((it) => {
        if (it.heading === getValues("ProductSelected")) {
          return {
            ...it,
            link: "",
            points: Array.isArray(it?.points)
              ? [...it.points, getValues("ProductSubItem")] // Append item to array
              : [getValues("ProductSubItem")], // Convert string to array if needed
          };
        }
        return it;
      });
    }
    setValue("ProductSubItem", "");
    setResponsibilities(item);
  };
  return (
    <div className="row">
      <div className="col-lg-6 col-12">
        <div className="input-blocks add-product list">
          <label>Heading</label>
          <div className="d-flex">
            <input
              type="text"
              className="form-control list"
              placeholder="Enter Product name"
              value={Res}
              onChange={(e) => setRes(e.target.value)}
            />
            <button
              className="btn btn-primary"
              onClick={(e) => {
                e.preventDefault(); // Prevents the default form submission
                AddDataArray();
              }}
            >
              Add
            </button>
          </div>
        </div>
      </div>
      {Responsibilities?.length > 0 && (
        <div className="col-12 mb-4 d-flex">
          <ul className="d-flex">
            {Responsibilities?.map((item, index) => (
              <li
                key={index}
                style={{
                  marginBottom: "5px",
                  marginRight: "10px",
                }}
              >
                <div className="px-2 d-flex bg-light text-black">
                  {item.heading}{" "}
                  <div
                    style={{ cursor: "pointer", paddingLeft: "10px" }}
                    onClick={() => RemoveDataArray(item.heading)}
                  >
                    <i className="fa-regular fa-circle-xmark text-danger"></i>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
      {Responsibilities?.length > 0 && <hr />}

      <div className="col-12">
        <div className="input-blocks add-product list">
          <label>Points</label>
          <div className="d-flex align-items-center">
            {/* Select dropdown on the left */}
            <select
              className="form-select me-2"
              // onChange={(val)}
              // value={selectedOption}
              onChange={(e) => setValue("ProductSelected", e.target.value)}
            >
              <option value="">Select a Product</option>
              {Responsibilities?.length > 0 &&
                Responsibilities?.map((item) => {
                  return (
                    <option key={item.heading} value={item.heading}>
                      {item.heading}
                    </option>
                  );
                })}
            </select>
            <select
              className="form-select me-2"
              onChange={(e) => setValue("ProductSubItemType", e.target.value)}
            >
              <option value={"point"}>Points</option>
              <option value={"link"}>Link</option>
            </select>

            {/* Input field in the middle */}
            <input
              type="text"
              className="form-control me-2"
              placeholder="Points"
              {...register("ProductSubItem")}
            />

            {/* Button on the right */}
            <button
              className="btn btn-primary"
              onClick={(e) => {
                e.preventDefault(); // Prevents the default form submission
                AddSubItem();
              }}
            >
              Add
            </button>
          </div>
        </div>
      </div>
      {Responsibilities?.length > 0 &&
        Responsibilities?.map((dat, i) => (
          <div key={i} className="col-lg-6 col-12 mb-4">
            <label className="fw-bold">{dat.heading}</label>
            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              {dat?.points?.length > 0 &&
                dat?.points?.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      marginBottom: "5px",
                    }}
                  >
                    <div className="px-2 d-flex justify-content-between bg-light text-black">
                      {item}{" "}
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => RemoveArraySubItem(dat.heading, item)}
                      >
                        <i className="fa-regular fa-circle-xmark text-danger"></i>
                      </div>
                    </div>
                  </li>
                ))}
              {dat?.link && dat?.link !== "" && (
                <a href={dat.link} target="blank">
                  {dat.link}
                </a>
              )}
            </ul>
          </div>
        ))}
    </div>
  );
};

export default MultiplePoints;
